<template>
  <div :class="['my-account', enableSidebar ? '' : 'no-sidebar']">
    <div class="bread-crumbs">
      <template v-for="(item, index) in breadcrumbs">
        <router-link v-if="item.path" :key="index" class="link-item" :to="item.path">{{ item.text }}</router-link>
        <a v-else :key="index">{{ item.text }}</a>
      </template>
    </div>
    <div class="content">
      <div class="primary">
        <router-view />
      </div>
      <div class="secondary">
        <router-link :class="[item.url == active ? 'current' : '', 'nav']" :to="{ name: item.url }" v-for="(item, index) in navBar"
          :key="index">{{ item.name }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
// import XNav from "../../components/AccountNav";
export default {
  // components: { XNav }
  data() {
    return {
      navBar: [
        { name: "个人信息", url: "Profile" },
        { name: "会员权益", url: "MemberBenefits" },
        { name: "我的卡券", url: "Coupons" },
        { name: "我的订单", url: "Orders" },
        { name: "地址管理", url: "Addressbook" },
        { name: "附近商店", url: "Store-finder" }
      ],
      active: ""
    };
  },
  created() {
    if (this.$route.name) {
      this.active = this.$route.name;
    }
  },
  computed: {
    enableSidebar() {
      const hideSidebar = ["Orderdetail", "afterSaleDetail",'orderTrack'];
      return !hideSidebar.includes(this.$route.name);
    },
    breadcrumbs() {
      let items = [
        { text: '首页', path: '/' },
        { text: '我的账户', path: '/account' }
      ];
      switch (this.$route.name) {
        case "Profile":
          items.push({ text: '个人信息' });
          break;
        case "Orders":
          items.push({ text: '我的订单' });
          break;
        case "Orderdetail":
          items.push({ text: '我的订单', path: '/myaccount/orders' });
          items.push({ text: '订单详情' });

          break;
        case 'afterSaleDetail':
          items.push({ text: '我的订单', path: '/myaccount/orders' });
          items.push({ text: '订单详情', path: `/myaccount/orderdetail?id=${this.$route.query.id}` });
          items.push({ text: '售后详情' });
          break;
        case "orderTrack":
          items.push({ text: '我的订单', path: '/myaccount/orders' });
          items.push({
            text: '订单详情',
            path: `/myaccount/orderdetail?id=${this.$route.query.id}`,
          });
          items.push({ text: '物流详情' });
          break;
        case "Addressbook":
          items.push({ text: '地址管理' });
          break;
        case "Store-finder":
          items.push({ text: '店铺导航' });
          break;
        default:
          break;
      }
      return items;
    }
  },
  watch: {
    $route(to) {
      this.active = to.name;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep a:hover {
  color: #000;
}

.iconfont {
  font-size: 40px;
  color: #000;
}

.my-account {
  box-sizing: border-box;
  max-width: 1200px;
  padding: 10px;
  margin: 0 auto;

  .bread-crumbs {
    box-sizing: border-box;
    margin: auto;
    width: 100%;
    max-width: 1200px;
    font-size: 16px;
    line-height: 1em;
    padding: 20px 0;
    text-align: left;
    display: none;

    a {
      font-size: 16px;
      color: #4B4F54;
    }

    a:hover {
      font-size: 16px;
      color: #333333;
    }

    .link-item {
      font-weight: 400;
      font-size: 16px;
      color: #999;
      letter-spacing: 0.025em;
      overflow: hidden;
      text-decoration: none;
      cursor: pointer;
      margin-right: 4px;

      &::after {
        color: #999;
        content: ">";
        margin-left: 0.4em;
        display: inline-block;
      }

      &:last-child::after {
        content: "";
      }

      &:hover {
        font-weight: 400;
        color: #999;
        text-decoration: underline;
      }
    }
  }

  .content {
    .secondary {
      display: none;
    }
  }

  &.no-sidebar {
    .content {
      .primary {
        padding-left: 0;
      }

      .secondary {
        display: none;
      }
    }
  }
}

@media only screen and (min-width: 768px) {
  .my-account {
    .content {
      display: flex;
      flex-direction: row-reverse;

      .primary {
        width: 100%;
      }

      .secondary {
        display: none;
      }
    }
  }
}

@media only screen and (min-width: 1025px) {
  .my-account {
    .bread-crumbs {
      display: block;
    }

    .content {
      display: flex;
      flex-direction: row-reverse;

      .primary {
        width: 100%;
        padding-left: 7%;
      }

      .secondary {
        width: 295px;
        height: 455px;
        box-sizing: border-box;
        border: 1px solid #d2d2dd;
        padding-top: 30px;
        display: flex;
        flex-direction: column;

        .nav {
          height: 50px;
          line-height: 50px;
          color: #333;
        }

        .current {
          border-left: 4px solid #000;
          background-color: #FBFBFB;
        }
      }
    }
  }
}
</style>